module.exports = __webpack_public_path__ + "img/outlook-icon.89ba856f.png";